export default __webpack_public_path__ + "static/media/030_corner1.hevc.e19540ca.mp4";